(function () {
  var navLinks = document.querySelectorAll('.faq-help__navlink');
  var cats = document.querySelectorAll('.faq-help__cat');
  if (!navLinks.length || !cats.length) return;

  navLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var id = link.getAttribute('data-target');
      var target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 24;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var id = entry.target.id;
      navLinks.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('data-target') === id);
      });
    });
  }, { rootMargin: '-40% 0px -50% 0px' });

  cats.forEach(function (cat) { observer.observe(cat); });
})();
